import { Autocomplete, AutocompleteChangeDetails, AutocompleteChangeReason, AutocompleteProps, 
  Box, Button, Popover, TextField } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import { FC, SyntheticEvent, useRef, useState } from "react";
import match from "autosuggest-highlight/match";
import parse from "autosuggest-highlight/parse";
import { SimpleOption } from "../governance/search/AmbientFacilitiesContext";


interface PopAutocompleteFilterProps {
  label: string;
  onChange?: (value: any[]) => void;
  AutocompleteProps?: Omit<AutocompleteProps<SimpleOption, false, true, false>, 'renderInput'>;
}

const PopAutocompleteFilter: FC<PopAutocompleteFilterProps> = (props) => {
  const { label, onChange, AutocompleteProps, ...other } = props;
  const anchorRef = useRef<HTMLButtonElement | null>(null);
  const [openMenu, setOpenMenu] = useState<boolean>(false);
  const comboboxRef = useRef<HTMLDivElement>()

  const handleOpenMenu = (): void => {
    setOpenMenu(true);
    setTimeout(() => {
      comboboxRef.current && comboboxRef.current.querySelector('input')?.focus()
    })
    setTimeout(() => {
      comboboxRef.current && comboboxRef.current.querySelector<HTMLButtonElement>('button.MuiAutocomplete-popupIndicator')?.click()
    }, 500)
  };

  const handleCloseMenu = (): void => {
    setOpenMenu(false);
  };

  return (
    <>
      <Button
        color="inherit"
        endIcon={<ExpandMoreIcon fontSize="small" />}
        onClick={handleOpenMenu}
        ref={anchorRef}
        {...other}
      >
        {label}
      </Button>
      {openMenu &&
        <Popover
          anchorEl={anchorRef.current}
          open={openMenu}
          onClose={handleCloseMenu}
          PaperProps={{ sx: {width: 380, p: 2} }}
        >
          <Autocomplete
            ref={comboboxRef}
            renderInput={(params) => <TextField {...params} label={label} />}

            {...(AutocompleteProps || {} as any)}
          />
        </Popover>}
    </>
  )
}

export default PopAutocompleteFilter;


export const PopBaseFilter : FC<{
  id: string,
  label: string,
  options: SimpleOption[],
  onChange?: ((
    event: SyntheticEvent<Element, Event>, 
    value: SimpleOption, reason: AutocompleteChangeReason, 
    details?: AutocompleteChangeDetails<any> | undefined) => void),
}> = ({ id, label, options, onChange }) => {
  return (
    <Box>
      <PopAutocompleteFilter
        label={label}
        AutocompleteProps={{
          id,
          options,
          getOptionLabel: (option) => option.text,
          renderOption: (props, option, { inputValue }) => {
            const matches = match(option.text, inputValue, {insideWords:true});
            const parts = parse(option.text, matches);

            return (
              <li {...props}>
                <Box sx={{ overflow: 'hidden', textOverflow: 'ellipsis', wordWrap: 'normal', whiteSpace: 'nowrap' }}>
                  {parts.map((part, index) => (
                    <span
                      key={index}
                      style={{
                        fontWeight: part.highlight ? 700 : 400,
                      }}
                    >
                      {part.text}
                    </span>
                  ))}
                </Box>
              </li>
            );
          },
          onChange,
        }}
      />
    </Box>
  )
}
